import { Selection } from "@at/design-system-elements";
import { ThemeSelectors } from "@at/design-system-foundation";

import styled from "styled-components";

import { isUserInRedButtonTest } from "../../../../../utils/ab-test/ab-test.util";

export const InStockSelection = styled(Selection)`
  .atds-field__label:hover {
    color: ${({ theme }) =>
      isUserInRedButtonTest
        ? ThemeSelectors.getDarkBlue(theme)
        : ThemeSelectors.getActionHoverColor(theme)};
  }
`;
